import React from 'react'
import Block from '../block'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { RichText } from '../richTextOptions'
import { Image } from '../BlockLibrary/Common/Image'
import { getIsPreviewStatus } from '../../state/app'

const ComponentFeaturedImage = ({ featuredList }) => {
	return (
		<div className="row">
			<div className="col-lg-6">
				<div className="featured-list-v2-left">
					{featuredList.title && (
						<div className="featured-list-v2-title">
							<RichText data={featuredList.title}></RichText>
						</div>
					)}
					{featuredList.image && (
						<div className="featured-list-v2-image is-desktop">
							<Image image={featuredList.image} />
						</div>
					)}
				</div>
			</div>
			<div className="col-lg-6">
				<div className="featured-list-v2-right">
					{featuredList.listContent && (
						<div className="featured-list-v2-content">
							<RichText data={featuredList.listContent}></RichText>
						</div>
					)}
					{featuredList.ctaButton && (
						<div className="featured-list-v2-button">
							<Block block={featuredList.ctaButton} />
						</div>
					)}
					{featuredList.image && (
						<div className="featured-list-v2-image is-mobile">
							<Image image={featuredList.image} />
						</div>
					)}
				</div>
			</div>
		</div>
	)
}

const ComponentFeatured = ({ featuredList }) => {
	return (
		<div className="featured-list-v2-wrapper">
			{featuredList.title && (
				<div className="featured-list-v2-title">
					<RichText data={featuredList.title}></RichText>
				</div>
			)}
			{featuredList.listContent && (
				<div className="featured-list-v2-content">
					<RichText data={featuredList.listContent}></RichText>
				</div>
			)}
			{featuredList.ctaButton && (
				<div className="featured-list-v2-button">
					<Block block={featuredList.ctaButton} />
				</div>
			)}
		</div>
	)
}

const SectionFeaturedListV2 = featuredList => {
	let hasImageFeatured = true;
	if (!featuredList.image) {
		hasImageFeatured = false;
	}
	let layoutClass = featuredList.layoutTemplate ? featuredList.layoutTemplate.replace(/ /g, '-').toLowerCase() : ''

	return (
		<section className={`featured-list-v2${!hasImageFeatured ? ' featured-v2-no-image' : ''} ${layoutClass}`}>
			<div className="container">
				{hasImageFeatured ? (<ComponentFeaturedImage featuredList={featuredList}></ComponentFeaturedImage>) : (
					<ComponentFeatured featuredList={featuredList}></ComponentFeatured>
				)}
			</div>
		</section>
	)
}

const mapStateToProps = state => {
	return {
		isPreview: getIsPreviewStatus(state),
	}
}

SectionFeaturedListV2.propTypes = {
	isPreview: PropTypes.bool,
}

const ContentfulSectionFeaturedListV2 = connect(mapStateToProps)(
	SectionFeaturedListV2
)

export { ContentfulSectionFeaturedListV2 }
